import React from 'react';
import { View, Text, StyleSheet, Image, Dimensions, Platform, ScrollView } from 'react-native';
import Colors from '../../../constants/Colors';
import CS from '../../../constants/Styles';
import { BackgroundGradient, Loader, Button, SafeAreaView } from '../../../components';
import UserState from '../../../src/contexts/UserState';
import { useLinkTo } from '@react-navigation/native';

const InviteSuccess = ({ navigation, route }) => {
  const [loading, setLoading] = React.useState(false);
  const [imgStyle, setImgStyle] = React.useState({});
  const [isProjectInvite, setIsProjectInvite] = React.useState(false);

  const [user, setUser] = React.useContext(UserState);

  const contractorClientText = user.isContractor ? 'customer' : 'contractor';
  const windowWidth = Dimensions.get('window').width;
  const linkTo = useLinkTo();

  React.useEffect(() => {
    setImgStyle(webImgStyle(windowWidth));

    if (Platform.OS === 'web') {
      const subscription = Dimensions.addEventListener('change', onChangeDimensions);
      return () => {
        subscription.remove();
        // Dimensions.removeEventListener('change', onChangeDimensions);
      }
    }
  }, []);

  React.useEffect(() => {
    if (route.params.projectId && route.params.projectId > 0){
      setIsProjectInvite(true);
    }
  }, [route.params?.projectId])

  React.useEffect(() => {
    console.log('route.params.inviteType: ', route.params.inviteType)
  }, [route.params?.inviteType])

  const onChangeDimensions = ({ window, screen }) => {
    setImgStyle(webImgStyle(window.width));
  };

  const webImgStyle = (windowWidth) => {
    if (Platform.OS === 'web') {
      const ratio = 696 / 672;
      const width = (windowWidth >= 768 ? 768 : windowWidth) * 0.6;
      console.log('logoStyle: ', width, width * ratio)
      return {
        width: width,
        height: width * ratio,
      }
    }
    return {};
  }

  const okay = () => {
    // if(route.params.inviteType === 'Project'){
    //   navigation.navigate('Project', {
    //     projectId: route.params.projectId,
    //     sentInvitation: true,
    //   });
    // } else if (route.params.inviteType === 'Customer'){
    //   navigation.navigate('Customer', {
    //     customerId: route.params.id,
    //   });
    // } else if (route.params.inviteType === 'Contractor') {
    //   navigation.navigate('Contractor', {
    //     companyId: route.params.id,
    //   });
    // }
    switch (route.params.inviteType) {
      case 'Customers':
        linkTo(`/customers`);
        return;
      case 'Contractors':
        linkTo(`/contractors`);
        return;
      case 'Customer':
        linkTo(`/customer/${route.params.customerId}`);
        return;
      case 'Contractor':
        linkTo(`/contractor/${route.params.contractorId}`);
        return;
      case 'Projects':
        linkTo(`/project/${route.params.projectId}?sentInvitation=yes`);
        return;
      default:
        linkTo('/projects');
        return;
    }
  }

  const renderSuccess = (inviteType) => {
    switch (inviteType) {
      case 'Create':
        return (
          <>
            <Text style={[CS.mediumText, CS.lightBlueText, CS.centerText, styles.msg]}>Follow up with your {contractorClientText}. Call, email or text/SMS them to make sure they have received the invitation to create your project.</Text>
            <Text style={[CS.mediumText, CS.lightBlueText, CS.centerText, styles.msg]}>If you or your {contractorClientText} need help or do not understand anything, please contact our Customer Support team - we are here to help!</Text>
          </>
        )
      case 'Customer':
      case 'Contractor':
      case 'Project':
        return (
          <>
            <Text style={[CS.mediumText, CS.lightBlueText, CS.centerText, styles.msg]}>Follow up with your {contractorClientText}. Call, email or text/SMS them to make sure they have received the invitation to join your project. {user.isContractor ? 'Once your customer accepts the project, they will need to fund it. When they do, you will be notified both when they send the money and again when it has cleared - so you can begin work.' : 'Ask them to join the project and let them know when they do, you will fund the project.'}</Text>
            <Text style={[CS.mediumText, CS.lightBlueText, CS.centerText, styles.msg]}>Your {contractorClientText} may want changes, if so, negotiate and make the necessary changes to your project in Renovation Trust.</Text>
            <Text style={[CS.mediumText, CS.lightBlueText, CS.centerText, styles.msg]}>If you or your {contractorClientText} need help or do not understand anything, please contact our Customer Support team - we are here to help!</Text>
          </>
        )
      case 'Quote':
        return (
          <>
            <Text style={[CS.mediumText, CS.lightBlueText, CS.centerText, styles.msg]}>Follow up with your {contractorClientText}. Call, email or text/SMS them to make sure they have received the invitation to quote your project.</Text>
            <Text style={[CS.mediumText, CS.lightBlueText, CS.centerText, styles.msg]}>If you or your {contractorClientText} need help or do not understand anything, please contact our Customer Support team - we are here to help!</Text>
          </>
        )
    }
  }

  return (
    <SafeAreaView style={CS.safe}>
      <View style={CS.container}>
        <BackgroundGradient />
        <Loader animating={loading} />
        {/* screen content */}
        <ScrollView style={styles.container} contentContainerStyle={styles.innerContainer}>
          <View style={styles.inviteImgContainer}>
            <Image source={require('../../../assets/img/invite_notify.png')} style={[CS.responsiveImage, styles.inviteImg, imgStyle]} />
          </View>
          {renderSuccess(route.params?.inviteType)}
          <View style={{ marginBottom: 10 }}>
            <Button text='Okay' onPress={() => okay} />
          </View>
        </ScrollView>
      </View>
    </SafeAreaView>
  );

}

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
  innerContainer: {
    width: '100%',
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    flexGrow: 1,
    alignSelf: 'center',
  },
  inviteImgContainer: {
    width: '60%',
    alignSelf: 'center',
    marginVertical: 20,
  },
  inviteImg: {
    aspectRatio: 672 / 696,
  },
  msg: {
    marginBottom: 20,
  },
});

export default InviteSuccess;